(() => {
  const GLOBAL_KEY = '__facetedSlideshowInteractionAutoplay';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].init(document);
    return;
  }

  const entries = new Set();
  let unlocked = false;

  const slidesFor = (root) => Array.from(root.querySelectorAll('[data-slide]'));
  const dotsFor = (root) => Array.from(root.querySelectorAll('[data-slide-dot]'));

  const currentIndex = (root, slides) => {
    const index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    return index < 0 ? 0 : index;
  };

  const show = (root, index) => {
    const slides = slidesFor(root);
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
    dotsFor(root).forEach((dot, i) => dot.setAttribute('aria-current', i === next ? 'true' : 'false'));
  };

  const primeNext = (entry) => {
    const slides = slidesFor(entry.root);
    if (slides.length < 2) return;
    const current = currentIndex(entry.root, slides);
    const nextSlide = slides[(current + 1) % slides.length];
    nextSlide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
      image.loading = 'eager';
    });
  };

  const stop = (entry) => {
    if (entry.timer) window.clearInterval(entry.timer);
    entry.timer = null;
  };

  const start = (entry) => {
    stop(entry);
    if (!unlocked || entry.pointerInside || entry.focusInside || document.hidden) return;
    primeNext(entry);
    entry.timer = window.setInterval(() => {
      const slides = slidesFor(entry.root);
      if (slides.length < 2) return;
      const current = currentIndex(entry.root, slides);
      show(entry.root, current + 1);
      primeNext(entry);
    }, entry.interval);
  };

  const interactionListeners = [
    [window, 'pointerdown', { capture: true, passive: true }],
    [window, 'touchstart', { capture: true, passive: true }],
    [window, 'wheel', { capture: true, passive: true }],
    [window, 'keydown', { capture: true }]
  ];

  const unlock = (event) => {
    if (unlocked || (event && event.isTrusted === false)) return;
    unlocked = true;
    interactionListeners.forEach(([target, type, options]) => target.removeEventListener(type, unlock, options));
    entries.forEach(start);
  };

  interactionListeners.forEach(([target, type, options]) => target.addEventListener(type, unlock, options));

  document.addEventListener('visibilitychange', () => {
    entries.forEach((entry) => document.hidden ? stop(entry) : start(entry));
  });

  const initRoot = (root) => {
    if (!root || root.dataset.autoplayAfterInteraction !== 'true' || root.dataset.performanceAutoplayInitialized === 'true') return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

    const slides = slidesFor(root);
    if (slides.length < 2) return;

    root.dataset.performanceAutoplayInitialized = 'true';
    const entry = {
      root,
      timer: null,
      interval: Number(root.dataset.interval) || 6000,
      pointerInside: root.matches(':hover'),
      focusInside: root.contains(document.activeElement)
    };
    entries.add(entry);

    root.addEventListener('mouseenter', () => {
      entry.pointerInside = true;
      stop(entry);
    });
    root.addEventListener('mouseleave', () => {
      entry.pointerInside = false;
      start(entry);
    });
    root.addEventListener('focusin', () => {
      entry.focusInside = true;
      stop(entry);
    });
    root.addEventListener('focusout', (event) => {
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      entry.focusInside = false;
      start(entry);
    });

    if (unlocked) start(entry);
  };

  const init = (scope = document) => {
    if (scope.matches?.('[data-slideshow]')) initRoot(scope);
    scope.querySelectorAll?.('[data-slideshow]').forEach(initRoot);
  };

  window[GLOBAL_KEY] = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init(document);
})();
